import { render, staticRenderFns } from "./PurchaseOrderDetails.vue?vue&type=template&id=11875e0f&scoped=true&"
import script from "./PurchaseOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderDetails.vue?vue&type=style&index=0&id=11875e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11875e0f",
  null
  
)

export default component.exports